/* ⚛ REACT */
import { useRef } from "react";

/* 📦 LIBS */
import { useTranslation } from "react-i18next";
import { useTour } from "@reactour/tour";
import { toast } from "react-toastify";

/* 🧩 COMPONENTS */
import { InputSelect, InputImage, Input, Label, Button, InputCheckbox, SaveIcon } from "../..";

/* 🧠 REDUX */
import { store } from "../../../Redux/Store";
import { useSelector } from "react-redux/es/hooks/useSelector";
import { changeModal } from "../../../Redux/Actions";

/* 📁 ASSETS*/
import { Alert, Excluir, Atualizar, Check, Error, UpdatePassword, Permissions } from "../../../Assets/icons";

/* 🎨 STYLES */
import { Title, ContainerRow, ContainerColumn, ImageIcon, ButtonsContainer } from "./styles";

/* 🔧 UTILS */
import { FormatPhone, FormatWpp, isValidEmail, isValidField, isValidPhone, isValidUser, isValidWpp } from "../../../util/validate";

const GeneralTab = ({ userId, Services, usuario, setUsuario, setActiveModal }) => {

    const { isOpen, currentStep } = useTour();

    const { t, i18n } = useTranslation();
    
    const user = useSelector(state => state.userReducer);
    const Locations = useSelector(state => state.UserCurdReducer.Locations);
    const LocationTypes = useSelector(state => state.UserCurdReducer.LocationTypes);
    const Cargos = useSelector(state => state.UserCurdReducer.Cargos);

    if(!userId){
        userId = user?.user?.id;
    };

    const userRef = useRef('');

    const alocacao_typeField = useRef();
    const alocacaoField = useRef();
    const CargoField = useRef();
    const LanguageField = useRef();
    const NameField = useRef();
    const UserField = useRef();
    const PhoneField = useRef();
    const WhatsappField = useRef();
    const MailField = useRef();

    const alocacaoValue = useRef();
    const CargoValue = useRef();
    const ImageValue = useRef();
    const LanguageValue = useRef();
    const NameValue = useRef();
    const UserValue = useRef();
    const PhoneValue = useRef();
    const WhatsappValue = useRef();
    const MailValue = useRef();

    const hasaccessparametricValue = useRef();
    const hasaccessallallocations = useRef();

    const language = [
        { id: "pt-br", name: "Português (Brasil)" },
        { id: "en", name: "Inglês (USA)" }
    ];

    // method-spoofing
    // Salva as edições do usuário
    const SaveUser = async() => {
        if(isValidUser(UserValue.current) && isValidField(NameValue.current) && isValidField(alocacaoValue.current) &&
        isValidField(PhoneValue.current) && isValidField(MailValue.current)){
            let form = new FormData();
            
            // if(ImageValue.current){form.append('hidden_file_image', ImageValue.current)}
            if(UserValue.current){form.append('username', UserValue.current)}
            if(LanguageValue.current){form.append('lang', LanguageValue.current)}
            if(NameValue.current){form.append('name', NameValue.current)}
            if(alocacaoValue.current){form.append('id_allocation', alocacaoValue.current)}
            if(CargoValue.current){form.append('role_id', CargoValue.current)}
            if(PhoneValue.current){form.append('phone', PhoneValue.current)}
            if(WhatsappValue.current){form.append('whatsapp', WhatsappValue.current)}
            if(MailValue.current){form.append('email', MailValue.current)}
    
            if(userRef.current?.hasaccessparametric !== hasaccessparametricValue.current){
                form.append('hasaccessparametric', hasaccessparametricValue.current === true ? '1' : '0');
            }
            if(userRef.current?.hasaccessallallocations !== hasaccessallallocations.current){
                form.append('hasaccessallallocations', hasaccessallallocations.current === true ? '1' : '0');
            }
            form.append('_method', 'PATCH');

            let newuser = await Services.current.editUser(userId, form);

            i18n.changeLanguage(newuser?.lang || 'pt-br');
            setUsuario(newuser);
        }else{
            toast(t("message.save"), {
                position: "top-center",
                type: 'info',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }
    }

    return(
        <div className="data-container">
            <Title>{usuario?.name}</Title>
            <ContainerRow onSubmit={(e) => e.preventDefault()}>
                <ContainerColumn>
                    <InputImage
                        id='foto' 
                        name='foto' 
                        validationFunction={(value) => isValidField(value)}
                        value={usuario?.photo_url}
                        deleteImage={() => {
                            setUsuario({...usuario, photo_url: null})
                            ImageValue.current = null
                            Services.current.deleteUserImage(userId);
                        }}
                        onchange={(value) => {
                            setUsuario({...usuario, photo_url: value})
                            ImageValue.current = value
                            Services.current.editUserImage(userId, value);
                        }}>
                    </InputImage>
                    {userId === user.user.id ?
                        <>
                            <Button 
                                text={t("buttons.update-password")}  
                                width={'100%'} 
                                onClick={() => store.dispatch(changeModal('changePasswordModal'))} 
                                icon={<ImageIcon src={UpdatePassword}/>}/>
                            <Button 
                                text={t("buttons.alerts")} 
                                width={'100%'} 
                                // disabled={true}
                                onClick={() => store.dispatch(changeModal('userSubscribes'))} 
                                icon={<ImageIcon src={Alert}/>}/>
                        </>
                    :<></>}

                    {usuario?.can_reset_2fa === true ?
                            <Button 
                                text={t("buttons.2fa-reset")} 
                                width={'100%'} 
                                disabled={isOpen && currentStep === 1} 
                                onClick={() => Services.current.enable2faReset(usuario.id)} 
                                icon={<ImageIcon src={Atualizar} />}/>
                        :<></>
                    }

                    {user?.user?.can?.includes('administrador.adm') && (
                        <>
                            <Button 
                            text={t("buttons.permissions")} 
                            width="100%"
                            onClick={() => {
                                store.dispatch(changeModal('userPermissions'));
                            }}
                            icon={<ImageIcon src={Permissions}/>}
                            />

                            {user?.user?.is_augen && (
                                <>
                                    <InputCheckbox 
                                        text={t("checkbox.has-access-parametric")} 
                                        id="parameterisation"
                                        onChange={(value) => {
                                        hasaccessparametricValue.current = value;
                                        setUsuario({...usuario, hasaccessparametric: value});
                                        }}
                                        checked={usuario?.hasaccessparametric}
                                    />

                                    <InputCheckbox 
                                        text={t("checkbox.has-access-all-allocations")} 
                                        id="hasaccessallallocations"
                                        onChange={(value) => {
                                            hasaccessallallocations.current = value;
                                            setUsuario({...usuario, hasaccessallallocations: value});
                                        }}
                                        checked={usuario?.hasaccessallallocations}
                                    />
                                </>
                            )}
                        </>
                    )}

                </ContainerColumn>
                <div className="personal-data">
                    <ContainerColumn className="input-column">
                        {userId === user?.user?.id &&
                            <>
                                <Label text={t("inputs.preferred-language.label")} aling="flex-start"/>
                                <InputSelect
                                    key="alocacao_type"
                                    name="alocacao_type"
                                    id="alocacao_type"
                                    placeholder={t("inputs.preferred-language.placeholder")}
                                    invalidMessage={t("inputs.preferred-language.invalid-message")}
                                    value={usuario?.lang}
                                    options={language}
                                    innerRef={LanguageField}
                                    validationFunction={(value) => isValidField(value)}
                                    onchange={(value) => LanguageValue.current = value}>
                                </InputSelect>
                            </>
                        } 
                        
                        <Label text={t("inputs.name.label")} aling="flex-start"/>
                        <Input 
                            aling="flex-start"
                            id="nome" 
                            name="nome" 
                            type="text" 
                            placeholder={t("inputs.name.placeholder")}
                            value={usuario?.name}
                            innerRef={NameField}
                            invalidMessage={t("inputs.name.invalid-message")}
                            validationFunction={(text) => isValidField(text)}
                            onchange={(text) => NameValue.current = text}> 
                        </Input>

                        <Label text={t("inputs.allocation-type.label")} aling="flex-start"/>
                        <InputSelect
                            key="alocacao_type"
                            name="alocacao_type"
                            id="alocacao_type"
                            placeholder={t("inputs.allocation-type.placeholder")}
                            invalidMessage={t("inputs.allocation-type.invalid-message")}
                            value={usuario?.allocation?.type?.name}
                            options={LocationTypes}
                            innerRef={alocacao_typeField}
                            validationFunction={(value) => isValidField(value)}
                            onchange={(value) => Services.current.ChangeLocationType(value, alocacaoField.current)}>
                        </InputSelect>

                        <Label text={t("inputs.allocation-local.label")} aling="flex-start"/>
                        <InputSelect
                            key="alocacao"
                            name="alocacao"
                            id="alocacao"
                            placeholder={t("inputs.allocation-local.placeholder")}
                            invalidMessage={t("inputs.allocation-local.invalid-message")}
                            options={Locations}
                            value={usuario?.allocation?.id}
                            innerRef={alocacaoField}
                            validationFunction={(value) => isValidField(value)}
                            onchange={(value) => alocacaoValue.current = value}>
                        </InputSelect>

                        <Label text={t("inputs.position.label")} aling="flex-start"/>
                        <InputSelect
                            key="cargo"
                            name="cargo"
                            id="cargo"
                            placeholder={t("inputs.position.placeholder")}
                            invalidMessage={t("inputs.position.invalid-message")}
                            value={usuario?.role?.id}
                            options={Cargos}
                            innerRef={CargoField}
                            validationFunction={(value) => isValidField(value)}
                            onchange={(value) => CargoValue.current = value}>
                        </InputSelect>

                    </ContainerColumn>

                    <ContainerColumn className="input-column">
                        <Label text={t("inputs.user.label")} aling="flex-start" icon={usuario?.security?.has2fa ? Check : Error}/>
                        <Input 
                            aling="flex-start"
                            id="user" 
                            name="user" 
                            type="text" 
                            placeholder={t("inputs.user.placeholder")}
                            value={usuario?.username}
                            innerRef={UserField}
                            invalidMessage={t("inputs.user.invalid-message")}
                            validationFunction={(text) => isValidUser(text)}
                            onchange={(text) => UserValue.current = text}> 
                        </Input>

                        <Label text={t("inputs.phone.label")} aling="flex-start" icon={usuario?.contacts?.phone_verified ? Check : Error}/>
                        <Input 
                            aling="flex-start"
                            id="telefone" 
                            name="telefone" 
                            mask="(99) 99999-9999"
                            type="tel" 
                            placeholder={t("inputs.phone.placeholder")}
                            innerRef={PhoneField}
                            value={FormatPhone(usuario?.contacts?.phone)}
                            invalidMessage={t("inputs.phone.invalid-message")}
                            validationFunction={(text) => isValidPhone(text)}
                            onchange={(text) => PhoneValue.current = text}> 
                        </Input>

                        <Label text={t("inputs.whatsapp.label")} aling="flex-start" icon={usuario?.contacts?.whatsapp_verified ? Check : Error}/>
                        <Input 
                            aling="flex-start"
                            id="whatsapp" 
                            name="whatsapp" 
                            mask="(99) (99) 9999-9999"
                            type="tel" 
                            value={usuario?.contacts?.whatsapp ?  FormatWpp(usuario?.contacts?.whatsapp) : ""  }
                            placeholder={t("inputs.whatsapp.placeholder")}
                            innerRef={WhatsappField}
                            invalidMessage={t("inputs.whatsapp.invalid-message")}
                            validationFunction={(text) => isValidWpp(text)}
                            onchange={(text) => WhatsappValue.current = text}> 
                        </Input>

                        <div id="confirm-email">
                            <Label text={t("inputs.email.label")} aling="flex-start" icon={usuario?.contacts?.email_verified ? Check : Error}/>
                            <Input 
                                aling="flex-start"
                                id="email" 
                                name="email" 
                                type="text" 
                                placeholder={t("inputs.email.placeholder")}
                                value={usuario?.contacts?.email ?  usuario?.contacts?.email : ""}
                                innerRef={MailField}
                                invalidMessage={t("inputs.email.invalid-message")}
                                validationFunction={(text) => isValidEmail(text)}
                                onchange={(text) => MailValue.current = text}> 
                            </Input>
                        </div>
                    </ContainerColumn>
                </div>
            </ContainerRow>

            <ButtonsContainer>
                {user?.user?.can?.includes('user.edit') || userId === user?.user?.id ?
                    <Button text={t("buttons.save")} width={'150px'} icon={<SaveIcon/>} onClick={() => SaveUser()}/>
                :<></>}
                {user?.user?.can?.includes('user.delete') ?
                    <Button text={t("buttons.delete")} width={'150px'} color={'white-red'} onClick={() => setActiveModal('delete-employee')} icon={<ImageIcon $isSpecial src={Excluir}/>}/>
                :<></>}
            </ButtonsContainer>
        </div>
    );
};

export default GeneralTab;